import { render, staticRenderFns } from "./CreateSocialEssayPage.vue?vue&type=template&id=d6fcc03a&scoped=true"
import script from "./CreateSocialEssayPage.vue?vue&type=script&lang=js"
export * from "./CreateSocialEssayPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6fcc03a",
  null
  
)

export default component.exports